import { Box, Button } from "@mui/material";
import ViewCad from "../../../config/view";
import { UsuarioViewProps } from "../usuario.controller";
import { Usuario } from "../usuario.model";
import { useState } from "react";

interface UsuarioCadastroProps extends UsuarioViewProps {
    handleCloseView: () => any
}

export function UsuarioCadastro(props: UsuarioCadastroProps) {
    const { usuarioActions,usuarioState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = usuarioState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = usuarioActions

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: Usuario) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Usuario) => {
        const errors: any = {}
        if (!values.nome)
            errors.nome = "Informe o nome do usuário"
        return errors
    }

    const handleUpdate = (value: Usuario) => {
        //verificar criação da senha
        //se for diferente é pq foi alterado ou esta sendo criado
        if(row.senha !== value.senha){
            //criptografa a senha
            let cripto_senha = btoa(value.senha);
            value.senha = cripto_senha;
        }

        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro do Usuário",
        formFieldDescription: "nome",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar novo usuário",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "nome", label: "Nome", type: "text", key: "nome", colunsXS: 12, colunsSM: 12 , colunsMD: 12, require: true },
            { fieldName: "login", label: "Login de Acesso", type: "text", key: "login", colunsXS: 12, colunsSM: 6, colunsMD: 6, require: true, },
            { fieldName: "senha", label: "Senha de Acesso", type: "password", key: "senha", colunsXS: 12, colunsSM: 6, colunsMD: 6, require: true, },
            { fieldName: "ativo", label: "Ativo", type: "checkbox", key: "ativo", colunsXS: 12, colunsSM: 6, colunsMD: 6 },
        ],
    })

    return viewCad
}



